import { isCN } from '@utils/origin';

export const getAuthProvider = () => {
  return isCN ? 'sso-oidc' : 'keycloak';
};

export const getAuthProviderBaseURI = () => {
  return isCN ? process.env.BASE_URI : process.env.KEYCLOAK_ISSUER;
};
